// Type for File node with ImageSharp
interface FileNode {
  id: string;
  publicURL?: string;
  childImageSharp?: {
    gatsbyImageData?: any;
    original?: {
      width: number;
      height: number;
    };
  };
}

// Type for AssetYaml GraphQL type
export interface AssetYamlType {
  id: string;
  yamlId?: string;
  title?: string;
  description?: string;
  fileName?: string;
  url?: string;
  contentType?: string;
  width?: number;
  height?: number;
  size?: number;
  dominantColor?: string;
  imageFile?: FileNode;
}

export default class Asset {
  id: string;
  yamlId?: string;
  title?: string;
  description?: string;
  fileName?: string;
  url?: string;
  contentType?: string;
  width?: number;
  height?: number;
  size?: number;
  dominantColor?: string;
  imageFile?: FileNode;
  constructor(asset: AssetYamlType) {
    this.id = asset.id;
    this.yamlId = asset.yamlId;
    this.title = asset.title;
    this.description = asset.description;
    this.fileName = asset.fileName;
    this.url = asset.url;
    this.contentType = asset.contentType;
    this.width = asset.width;
    this.height = asset.height;
    this.size = asset.size;
    this.dominantColor = asset.dominantColor;
    this.imageFile = asset.imageFile;
  }

  get isImage(): boolean {
    return this.contentType?.startsWith("image/") || false;
  }

  get isVideo(): boolean {
    return this.contentType?.startsWith("video/") || false;
  }
}
